module.exports = __webpack_public_path__ + "static/media/00_gauchahoje_mobile.9b5d9479.jpg";